type FooterSectionHeaderProps = {
  title: string;
  variant?: 'default' | 'referral' | 'events';
};

export const FooterSectionHeader = ({ title, variant = 'default' }: FooterSectionHeaderProps) => {
  const colorClass = variant === 'referral' || variant === 'events' ? 'tw-text-[#2D5EFF]' : 'tw-text-[#527CD0]';
  return <div className={`tw-text-[18px] tw-font-bold ${colorClass} lg:tw-mb-2.5`}>{title}</div>;
};

// styles from Figma
// color: #527CD0;
// font-family: Rajdhani;
// font-size: 18px;
// font-style: normal;
// font-weight: 700;
// line-height: 30px; /* 166.667% */
